import React, { FC } from 'react';

export interface Props {}

const OffScreenNodeId = 'off-screen-node';

const defaultProps: Props = {
	id:    OffScreenNodeId,
	style: {
		display:  'inline-block',
		position: 'fixed',
		width:    1,
		height:   1,
		top:      -1,
		left:     -1,
	}
};

const OffScreenNode: FC<Props> = ( props ) => <div { ...props } />;

const getOffScreenNodeElement = () => document.getElementById( OffScreenNodeId )

OffScreenNode.defaultProps = defaultProps;

export { OffScreenNode, getOffScreenNodeElement }
